<template>
	<div class="comp">
		<div class="grid help hidden-xs">
			<el-tooltip class="item" effect="dark" content="Aiuto" placement="top">
				<a href="https://blog.ombrelleria.com/" target="new">
					<unicon name="question-circle" height="24" width="24" fill="#fff" />
				</a>
			</el-tooltip>
		</div>
		<div class="grid subusers comp-inner">

			<div class="grid header">
				<div class="grid sectiontitle"><span @click="show('dashboard')"><unicon name="arrow-left" height="32" width="32" /></span> Utenze</div>
				<div class="grid settings">
			<transition name="slide-fade">
				<button @click="add = true, editsubuser = false, subuser = newsubuser" v-if="hotel.subusers.length > 0" :disabled="add" class="btn green"><unicon name="user-plus" fill="#fff" /><span class="hidden-xs"> aggiungi utente</span></button>
			</transition>
			<button @click="openmenu()" class="btn"><i class="fas fa-bars"></i></button>
				</div>
			</div>

			<div class="grid subuserlist">
		<!-- {{hotel.subusers}} -->
		<transition name="slide-fade">
			<div class="grid list"  v-loading="hotelloading">
				<!-- <div class="grid user" v-for="user in hotel.subusers" :key="user.email" :class="{red: deletesubuser}"> -->
					<transition-group name="slide-fade" class="grid user flatbox border" v-if="owner" style="margin-bottom: 16px;">
						<!-- {{subuser}} -->
						<!-- <span class="grid" key="quest" v-if="deletesubuser  && subuser.userid === user.userid">Sicuro di voler rimuovere {{user.name}} ?</span> -->
						<span class="grid name" key="name" v-if="$store.state.user.profile.name">{{owner.name}}</span>
						<span class="grid name" key="name" v-else>Gestore</span>
						<span class="grid email" key="email">{{owner.email}}</span>
						<span class="grid privileges" key="privileges" v-if="!deletesubuser">
							<el-tooltip class="item" effect="dark" content="Admin" placement="top">
								<unicon name="jackhammer" :fill="$store.state.user.privileges.owner ? '#12C300' : '#808080'" />
							</el-tooltip>
							<el-tooltip class="item" effect="dark" content="Controllo" placement="top">
								<unicon name="qrcode-scan" :fill="$store.state.user.privileges.owner ? '#12C300' : '#808080'" />
							</el-tooltip>
							<el-tooltip class="item" effect="dark" content="Gestione ospiti" placement="top">
								<unicon name="clipboard-notes" :fill="$store.state.user.privileges.owner ? '#12C300' : '#808080'" />
							</el-tooltip>
						</span>
						<span class="grid actions disabled" key="actions">
							<!-- owner -->
							<unicon name="file-edit-alt" />
							<unicon name="trash" />
						</span>
					</transition-group>
					<transition-group name="slide-fade" class="grid user flatbox" v-for="(user, index) in hotel.subusers" :key="index" :class="{red: deletesubuser && subuser.userid === user.userid, active: editsubuser && subuser.userid === user.userid}">
						<!-- {{subuser}} -->
						<span class="grid" key="quest" v-if="deletesubuser  && subuser.userid === user.userid">Sicuro di voler rimuovere {{user.name}} ?</span>
						<span class="grid name" key="name" v-if="!deletesubuser">{{user.name}}</span>
						<span class="grid email" key="email" v-if="!deletesubuser">{{user.email}}</span>
						<span class="grid privileges" key="privileges" v-if="!deletesubuser">
							<el-tooltip class="item" effect="dark" content="Admin" placement="top">
								<unicon name="jackhammer" :fill="user.privileges.admin ? '#12C300' : '#808080'" />
							</el-tooltip>
							<el-tooltip class="item" effect="dark" content="Controllo" placement="top">
								<unicon name="qrcode-scan" :fill="user.privileges.checkqr ? '#12C300' : '#808080'" />
							</el-tooltip>
							<el-tooltip class="item" effect="dark" content="Gestione ospiti" placement="top">
								<unicon name="clipboard-notes" :fill="user.privileges.editbeach ? '#12C300' : '#808080'" />
							</el-tooltip>
						</span>
						<span class="grid actions" :class="{disabled: user.userid == $store.state.jwt.user}" key="actions" v-if="!deletesubuser">
							<unicon name="file-edit-alt" @click="(user.userid === $store.state.jwt.user) ? nothing() : (add = false, editsubuser = true, subuser = user)" />
							<unicon name="trash" @click="(user.userid === $store.state.jwt.user) ? nothing() : (deletesubuser = true, add = false, editsubuser = false, subuser = user)" />
						</span>
						<span class="grid actions" key="actions2" v-if="deletesubuser  && subuser.userid === user.userid">
							<button @click="deletesubuser = false, subuser = {}" class="btn secondary light sm">no</button>
							<button @click="removeSubuser(user)" class="btn reddark sm"><unicon name="trash-alt" fill="#fff" height="16" width="16" /> si, rimuovi</button>
						</span>
					</transition-group>
				<!-- </div> -->
			</div>
		</transition>

		<transition name="slide-fade" v-if="hotel.subusers.length < 1 && !add">
			<div class="grid empty" style="grid-column: 1; grid-row: 2; margin-top: 64px;">
				non hai ancora aggiunto utenze
				<button @click="add = true, subuser = newsubuser" class="btn green" v-loading="userloading"><unicon name="user-plus" fill="#fff" /> aggiungi utente</button>
			</div>
		</transition>

<!-- 		<transition name="slide-fade">
			<div class="grid list" v-if="hotel.subusers.length > 0" v-loading="hotelloading">
					<transition-group name="slide-fade" class="grid user flatbox" v-for="user in hotel.subusers" :key="user.email" :class="{red: deletesubuser && subuser.userid === user.userid, active: editsubuser && subuser.userid === user.userid}">
						<span class="grid" key="quest" v-if="deletesubuser  && subuser.userid === user.userid">Sicuro di voler rimuovere {{user.name}} ?</span>
						<span class="grid name" key="name" v-if="!deletesubuser">{{user.name}}</span>
						<span class="grid email" key="email" v-if="!deletesubuser">{{user.email}}</span>
						<span class="grid privileges" key="privileges" v-if="!deletesubuser">
							<el-tooltip class="item" effect="dark" content="Admin" placement="top">
								<unicon name="jackhammer" :fill="user.privileges.admin ? '#12C300' : '#808080'" />
							</el-tooltip>
							<el-tooltip class="item" effect="dark" content="Controllo" placement="top">
								<unicon name="qrcode-scan" :fill="user.privileges.checkqr ? '#12C300' : '#808080'" />
							</el-tooltip>
							<el-tooltip class="item" effect="dark" content="Gestione ospiti" placement="top">
								<unicon name="clipboard-notes" :fill="user.privileges.editbeach ? '#12C300' : '#808080'" />
							</el-tooltip>
						</span>
						<span class="grid actions" :class="{disabled: user.userid == $store.state.jwt.user}" key="actions" v-if="!deletesubuser">
							<unicon name="file-edit-alt" @click="(user.userid === $store.state.jwt.user) ? nothing() : (add = false, editsubuser = true, subuser = user)" />
							<unicon name="trash" @click="(user.userid === $store.state.jwt.user) ? nothing() : (deletesubuser = true, add = false, editsubuser = false, subuser = user)" />
						</span>
						<span class="grid actions" key="actions2" v-if="deletesubuser  && subuser.userid === user.userid">
							<button @click="deletesubuser = false, subuser = {}" class="btn secondary light sm">no</button>
							<button @click="removeSubuser(user)" class="btn reddark sm"><unicon name="trash-alt" fill="#fff" height="16" width="16" /> si, rimuovi</button>
						</span>
					</transition-group>
			</div>
		</transition> -->

		<transition name="slide-fade">
			<div class="grid box" v-if="add || editsubuser">
				<div class="grid header">
					<span class="grid title" v-if="add">Aggiungi utente</span>
					<span class="grid title" v-if="editsubuser">Modifica utente</span>
				</div>
				<div class="grid body">
					<el-form ref="subuserform" :model="subuser" status-icon>
						<div class="grid items">
							<el-form-item label="Nome" key="name" prop="name" class="input">
								<el-input type="text" v-model="subuser.name" name="name"></el-input>
							</el-form-item>
							<el-form-item label="Indirizzo email" key="email" prop="email" class="input">
								<el-input type="text" v-model="subuser.email" name="email"></el-input>
							</el-form-item>
							<div class="spacer xs"></div>
							<div class="grid item">
								<span class="grid icon"><unicon name="jackhammer" /></span>
								<span class="grid name">Admin</span>
								<span class="grid badge">
									<el-switch v-model="subuser.privileges.admin"></el-switch>
								</span>
							</div>
							<div class="grid item">
								<span class="grid icon"><unicon name="qrcode-scan" /></span>
								<span class="grid name">Controllo Check-in</span>
								<span class="grid badge">
									<el-switch v-model="subuser.privileges.checkqr"></el-switch>
								</span>
							</div>
							<div class="grid item">
								<span class="grid icon"><unicon name="clipboard-notes" /></span>
								<span class="grid name">Gestione ospiti</span>
								<span class="grid badge">
									<el-switch v-model="subuser.privileges.editbeach"></el-switch>
								</span>
							</div>
							<div class="spacer xs"></div>
						</div>
					</el-form>
					
					<div class="grid btnlist">
						<button @click="add ? (add = false, subuser = {}) : editsubuser = false" class="btn"><unicon name="times" /></button>
						<button @click="addSubuser()" class="btn green" v-if="add" v-loading="userloading"><unicon name="save" fill="#fff" /> Salva utente</button>
						<button @click="updateSubuser()" class="btn green" v-if="editsubuser" v-loading="userloading"><unicon name="save" fill="#fff" /> Salva modifiche</button>
					</div>
					
				</div>
			</div>
		</transition>

			</div>

	</div>
</div>
</template>

<script>
// import _ from 'lodash'
// import moment from 'moment'
import helper from '../Mixins/helper'
export default {
	name: 'Subusers',
	mixins: [helper],
	props: {
		hotel: Object
	},
	data () {
	return {
		changes: false,
		add: false,
		deletesubuser: false,
		editsubuser: false,
		owner: {},
		subuser: {},
		newsubuser: {
			name: '',
			email: '',
			privileges: {
				admin: false,
				checkqr: true,
				editbeach: false,
				editbookings: false
			}
		}
	}
	},
	methods: {
	show (section) {
		// console.log(section)
		this.$emit('open', section)
	},
	addSubuser () {
		console.log('addSubuser')
		this.$store.dispatch('users/addSubuser', this.subuser)
		this.add = false
		this.subuser = {}
	},
	removeSubuser (user) {
		console.log('removeSubuser')
		this.$store.dispatch('users/removeSubuser', user)
		this.deletesubuser = false
	},
	updateSubuser () {
		console.log('updateSubuser')
		this.$store.dispatch('users/updateSubuser', this.subuser)
		this.editsubuser = false
	}
	},
	filters: {

	},
	watch: {

	},
	computed: {
	// hotel () {
	// 	return JSON.parse(JSON.stringify(this.$store.state.hotels.activehotel))
	// },
	userloading () {
		return this.$store.state.users.loading
	},
	hotelloading () {
		return this.$store.state.hotels.loading
	}
	},
	beforeMount () {
		this.$store.dispatch('hotels/getOwner').then(data => {
			console.log(data)
			this.owner = data
		}, error => {
			console.log(error)
		})
	},
	beforeDestroy () {

	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fade-enter-active {
	transition: opacity .5s;
}
.fade-leave-active {
	transition: opacity 0s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
	opacity: 0;
}
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
	transition: all .3s ease;
}
.slide-fade-leave-active {
	transition: all 0s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
	transform: translateY(10px);
	opacity: 0;
}
</style>
